export default class TimeSlotManager {
  static resetNoDraft(events) {
    return events.filter(x => x.config.draft)
  }

  static removeId(events, id) {
    return events.filter(x => id !== x.id)
  }

  static findById(events, id) {
    return events.find(x => id == x.id)
  }
  static findByCategory(events, category) {
    return events.find(x => category == x.category)
  }


  static addDraft(events, category, start, end) {
    const event = {
      id: Date.now(),
      category: category,
      start: start,
      end: end,
      timed: true,
      color: 'transparent',
      config: {
        movable: true,
        draft: true,
      },
    }
    events.push(event)
    return event
  }

  static addEvent(events, category, start, end) {
    const event = {
      id: Date.now(),
      category: category,
      start: start,
      end: end,
      timed: true,
      color: 'transparent',
      config: {
        movable: true,
        draft: false,
      },
    }
    events.push(event)
    return event
  }

  static duplicateBlock(events, e, start, end) {
    const event = {
      id: Date.now(),
      category: e.category,
      start: start,
      end: end,
      timed: true,
      color: 'transparent',
      data: {
        id: e.data.id,
        priority: e.data.priority,
      },
      config: {
        movable: false,
        draft: false,
        block: e.config.block,
        blockType: e.config.blockType,
      },
    }
    events.push(event)
    return event
  }

  static addWorkingTime(events, start, end, category, lunch = false, id = null) {
    const event = {
      id: Date.now(),
      category: category,
      start: start,
      end: end,
      timed: true,
      color: 'transparent',
      data: {
        id: id,
        priority: 1,
        lunch: lunch,
      },
      config: {
        movable: false,
        draft: false,
        block: true,
        blockType: 'working',
      },
    }
    events.push(event)
    return event
  }

  static addIndispoBlock(events, start, end, category, id, type, text, recurenceId, recData,status,text_exception) {
    const event = {
      id: Date.now(),
      category: category,
      start: start,
      end: end,
      timed: true,
      color: 'transparent',
      data: {
        id: id,
        _type: type,
        priority: 3,
        text: text_exception ?? text,
        recurenceId: recurenceId,
        status_exception: status,
        recData: recurenceId ? recData.sort((a, b) => a.start.localeCompare(b.start)) : null
      },
      config: {
        movable: false,
        draft: false,
        block: true,
        blockColor: '#656565',
      },
    }
    events.push(event)
    return event
  }

  static addEstablishmentBlock(events, start, end, category) {
    const event = {
      id: Date.now(),
      category: category,
      start: start,
      end: end,
      timed: true,
      color: 'transparent',
      data: {
        id: null,
        priority: 2,
      },
      config: {
        movable: false,
        draft: false,
        block: true,
        blockType: 'establishment',
        blockColor: '#E4E4E4',
      },
    }
    events.push(event)
    return event
  }

  static addEstablishmentException(events, start, end, category) {
    const event = {
      id: Date.now(),
      category: category,
      start: start,
      end: end,
      timed: true,
      color: 'transparent',
      data: {
        id: null,
        priority: 4,
      },
      config: {
        movable: false,
        draft: false,
        block: true,
        blockType: 'establishment',
        blockColor: '#E3B0B0',
      },
    }
    events.push(event)
    return event
  }
  static  deleteDuplicate(arr, key , key2, key21) {
    return [...new Map(arr.map(item => [item[key2][key21]+'-'+item[key], item])).values()]

}
  static mergeBlock(events, real = false) {
    const blocks = !real
      ? events.filter(x => x.config.block).sort((a, b) => b.data.priority - a.data.priority)
      : events.filter(x => x.config.block || !x.config.draft).sort((a, b) => b.data.priority - a.data.priority)

    //
    for (const key in blocks) {
      for (const key2 in blocks) {
        if (key2 === key) continue

        const b1 = blocks[key]
        const b2 = blocks[key2]

        if (b1.category != b2.category || b1.data.priority === b2.data.priority) continue

        var date1 = [moment(b1.start), moment(b1.end)]
        var date2 = [moment(b2.start), moment(b2.end)]

        var range = moment.range(date1)
        var range2 = moment.range(date2)

        if (range.overlaps(range2)) {
          // hight && minus
          const h = b1.data.priority < b2.data.priority ? b2 : b1
          const m = b1.data.priority < b2.data.priority ? b1 : b2

          if (m.start < h.start && h.end < m.end) {
            TimeSlotManager.duplicateBlock(events, m, h.end, m.end)
            m.end = h.start
            return this.mergeBlock(events, real)
          }

          if (h.start <= m.start && m.end <= h.end) {
            m.start = 0
            m.end = 0
          }

          if (h.start <= m.start && m.start <= h.end) {
            m.start = h.end
          }

          if (h.start <= m.end && m.end <= h.end) {
            m.end = h.start
          }
        }
      }
    }

    return events
  }

  static deleteDraft(events, eventId) {
    return events.filter(x => x.id !== eventId)
  }

  static deleteAllDraft(events) {
    return events.filter(x => !x.config.draft)
  }

  static addList(events, hideEvents, dataList, cible, assocColor) {
    if (!dataList) return
//console.log(JSON.stringify(dataList))
    dataList.forEach(z => {
      if (!z || !z.timeslot) return
      const x = z.timeslot
      if (z.paymentSave) {
        z.paymentSave = 1
      }
      if (!z.type) {
        z.type = ''
      }
      if (hideEvents.find(t => t === x.id)) return

      if (x.package_id && !assocColor[`${x.package_id}-${x.booking[0].id}`]) {
        assocColor[`${x.package_id}-${x.booking[0].id}`] = `#${Math.floor(Math.random() * 16777215).toString(16)}`
      }

      const event = {
        id: `slot-${x.id}`,
        category: cible,
        start: x.start * 1000,
        end: (x.end + (x.cleanning_time + x.preparation_time) * 60) * 1000,
        timed: true,
        color: 'transparent',
        package_id: x ? x.package_id : null,
        group_uid: x ? x.groupe_uid : null,
        package_name: x && x.package_id ? x.package.name : null,
        data: {
          priority: 99,
          id: x.id,
          order_id: x.booking[0].just_order.id,
          client: `${x.first_name} ${x.last_name}`,
          status: x.status,
          phone_number: ((x.customer!=null)?((x.customer.phone_number==null)?'Non disponible':x.customer.phone_number):'Non disponible'),
          effectiveTime: (x.end - x.start) / 60,
          bookingId: x.booking[0].id,
          status: (x.booking[0].just_order.status_id==17)?17:x.booking[0].status,
          paid: ((x.booking[0].just_order.total_price == x.booking[0].just_order.current_price)||(x.booking[0].just_order.total_price-x.booking[0].just_order.current_price-x.booking[0].just_order.remise_price).toFixed(2)==0),
          paidIncomplete: x.booking[0] && x.booking[0].just_order && (x.booking[0].just_order.total_price && x.booking[0].just_order.total_price-x.booking[0].just_order.current_price-x.booking[0].just_order.remise_price).toFixed(2)>0 && x.booking[0].just_order.current_price != 0,
          paidFree: x.booking[0].total === null,
          paidFingerprint: x.booking[0].just_order ? x.booking[0].just_order.fingerprints : null,
          note: x.note,
          bookingNote: x.booking[0].note,
          staffsName:  x.staffs,
          prestation: {
            id: x.prestation != null ? x.prestation?.id : null, //FRED ERREUR CALENDRIER
            name: x.prestation != null ? x.prestation?.name : "Erreur chargment prestation",
            preparation_time: x.prestation != null ? x.prestation?.preparation_time : 0,
            cleaning_time: x.prestation != null ? x.prestation?.cleaning_time : 0,
          },
          info: {
            linkedCure: z.type.includes('Treatment'),
            linkedAbo: z.type.includes('Serie'),
            linkedForfait: z.type.includes('Package'),
            linkedBonCadeau: z.haveVoucher,
            colorCategory: z.colorCategory,
            colorSubcategory: z.colorSubcategory,
            createdOnline: z.is_online === 1,
            customerHasCard: z.paymentSave === 1,
            forfaitColor: assocColor[`${x.package_id}-${x.booking[0].id}`],
            rebooking: x.rebooking
          },
          pause: {
            enable: x.block_end != 0,
            startPos: (x.block_start / (x.duration_prestation + x.cleanning_time)) * 100,
            endPos: (x.block_end / (x.duration_prestation + x.cleanning_time)) * 100,
            practicienne: x.status_block === 1 || x.status_block === 3,
            salle: x.status_block === 2 || x.status_block === 3,
            block: x.cleanning_time,
            blockStart: x.start * 1000 + x.block_start * 60000,
            blockEnd: x.start * 1000 + x.block_end * 60000,
            blockPercent: (x.cleanning_time / (x.duration_prestation + x.cleanning_time)) * 100,
          },
        },
        config: {
          movable: false,
          draft: false,
        },
      }
      events.push(event)
      //console.log(JSON.stringify(events))

    })
  }

  static computedMaxBlock(events) {
    const res = this.groupBy(events, 'category')
    let counter = {}

    for (const key in res) {
      for (const [index, b1] of res[key].entries()) {
        let nbBock = 1

        for (const [index2, b2] of res[key].entries()) {
          if (index === index2) continue

          var date1 = [moment(b1.start), moment(b1.end)]
          var date2 = [moment(b2.start), moment(b2.end)]
          var range = moment.range(date1)
          var range2 = moment.range(date2)

          if (range.overlaps(range2)) {
            nbBock += 1
          }
        }

        if (!counter[key]) counter[key] = nbBock
        else if (counter[key] < nbBock) counter[key] = nbBock
      }
    }
    return counter
  }

  static groupBy(xs, key) {
    return xs.reduce(function(rv, x) {
      ;(rv[x[key]] = rv[x[key]] || []).push(x)
      return rv
    }, {})
  }


}
